export const tipoAreaMapa = {
  cozinha: 'Cozinha',
  bar: 'Bar',
  deposito: 'Depósito',
  producao: 'Produção',
  trancado: 'Trancado',
  central: 'Estoque Central',
  outro: 'Outro',
}


export const tipoAreaColumnOptions = {
  COZINHA: 'Cozinha',
  BAR: 'Bar',
  DEPOSITO: 'Depósito',
  PRODUCAO: 'Produção',
  TRANCADO: 'Trancado',
  CENTRAL: 'Estoque Central',
  OUTRO: 'Outro',
}


